<div class="container my-5">
  <div class="row titolo-pagina">
    <div class="col-12">
      <h1 class="mb-5">
        {{ (risultati.length > 0 ? 'RISULTATI_RICERCA_PER' : 'NESSUN_RISULTATO_PER') | translate | htmlToText}}: "{{termine}}"
      </h1>
      <div class="risultati">
        <p>
          <span *ngFor="let risultato of risultati">
            <a *ngIf="risultato.tipoOggetto === 'SCHEDA'" class="text-underline" 
              [appHref]="'/' + risultato.categorie[0]?.seo?.slug + '/' + risultato.sottocategorie[0]?.seo?.slug + '/' + risultato.seoOggetto?.slug">{{risultato.titolo}}</a>
            <a *ngIf="risultato.tipoOggetto === 'PAGINA'" class="text-underline" 
              [appHref]="'/informazioni/' + risultato.seoOggetto?.slug">{{risultato.titolo}}</a>
            ,
          </span>
          
        </p>
      </div>
    </div>
  </div>
</div>
